import CaretLeftIcon from "@/assets/icons/CaretLeftIcon";
import { Button } from "@/components/ui";
import EditIcon from "@/assets/icons/EditIcon";
import micrositeTemplatesData from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/micrositeTemplateTypesData";
import FramebaseTemplate from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/Templates/FramebaseTemplate/FramebaseTemplate";
import { useMicroSiteContext } from "@/contexts/MicroSiteContext";
import BrandingForm from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/Templates/Shared/BrandingForm";
import { MicroSiteRequestSchema, ProgrammeFormData} from "@/lib/api";
import { showToast } from "@/lib/toast";
import FlowkitTemplate from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/Templates/FlowkitTemplate/FlowkitTemplate";
import SitecraftTemplate from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/Templates/SitecraftTemplate/SitecraftTemplate";
import { useState } from "react";


interface PreviewAndEditMicrositeProps {
  nextStep: () => void;
  prevStep: () => void;
  handleFormData: (data: ProgrammeFormData) => void;
  formValues: ProgrammeFormData;
}
 
const PreviewAndEditMicrosite = ({nextStep, prevStep, handleFormData, formValues}: PreviewAndEditMicrositeProps) => {

  
  
  const [selectedTemplateId, setSelectedTemplate] = useState(formValues.microSiteRequest?.micrositeTemplateType || '');
  const [openBrandingForm, setOpenBrandingForm] = useState(false);

const { templatePayload, updateTemplatePayload } = useMicroSiteContext();


const handleProceed = () => {
  const updatedTemplatedPayload = {
    ...templatePayload,
    micrositeTemplateType: selectedTemplateId.toUpperCase()
  };


const isPayloadValid = MicroSiteRequestSchema.parse(updatedTemplatedPayload);

if (!isPayloadValid) {
    showToast.error('Template payload is invalid. Please check the data and try again.');
    return;
  }

  updateTemplatePayload(updatedTemplatedPayload);
                        nextStep();
                        handleFormData({ ...formValues, microSiteRequest: updatedTemplatedPayload });
};


  const renderTemplate = (id: string | null) => {
 
    switch(id?.toLowerCase()){
      case 'framebase_template':
        return <FramebaseTemplate />;
      case 'sitecraft_template':
        return <SitecraftTemplate />;
      case 'flowkit_template':
        return <FlowkitTemplate />;
      default:
        return <div>Please select a template</div>;
    }
  }
  return (
    <div>
      {/* Heading */}
      {<div className="bg-black p-4 md:px-8 flex items-center justify-between sticky top-0 z-50">
                <div className="flex items-center gap-2">
                 
                    <Button type="button" variant="secondary" onClick={prevStep} className="gap-1">
                      <CaretLeftIcon width={16} height={16} />
                    Previous
                  </Button>
                 
      
                  <div className="">
                  <Button onClick={()=> setOpenBrandingForm(true)} variant="ghost" className="text-white hover:bg-transparent">
                      <EditIcon />
                      Edit Brand
                    </Button>  
                    
                  </div>
                </div>

<div>
  <select 
  onChange={(e)=>{
    const selectedTemplateId = e.target.value;
    setSelectedTemplate(selectedTemplateId);
  }}
  className="bg-gray-800 text-white rounded-md px-3 py-2 mr-4">
    {micrositeTemplatesData.map((template) => (
      <option 
      key={template.id}
      value={template.id}
      selected={template.id === selectedTemplateId}
      >{template.name}</option>
    ))}
  </select>
</div>

                <div  className="flex gap-6 items-center">
                  <Button
                    variant="primary"
                    onClick={handleProceed}
                  >
                    Proceed
                  </Button>
                </div>
      
              </div>}
              {
                openBrandingForm && <div className="absolute top-20 left-0 transform  z-50 bg-white shadow-lg md:w-1/2 lg:w-1/3">
                  <BrandingForm handleCancel={() => setOpenBrandingForm(false)}  />
                </div> 
              }              
      <div >{renderTemplate(selectedTemplateId)}</div>
    </div>
  )
}

export default PreviewAndEditMicrosite